import { render, staticRenderFns } from "./collection-dynamic-page-range.vue?vue&type=template&id=5642e42f&"
import script from "./collection-dynamic-page-range.vue?vue&type=script&lang=js&"
export * from "./collection-dynamic-page-range.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports